export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/icon-sound-off-a015cf29311be0ba507481ff682786f7.svg";